import * as React from 'react';
import { useParams } from 'react-router';
import { useGetAdminTenantsTenantIdProjects } from '@/__generated__/admin/admin';
import { DataTable, Column } from '@/features/pagination/components/DataTable';
import { usePagination } from '@/features/pagination/hooks/usePagination';
import { formatDate } from '@/utils/date';
import { Project } from '@/__generated__/model/project';
import { CreateProjectDialog } from './CreateProjectDialog';

export function ListProjectsPage() {
  const { tenantId } = useParams();
  const { page, perPage, handlePageChange } = usePagination();

  const { data, isLoading, mutate } = useGetAdminTenantsTenantIdProjects(String(tenantId), {
    page,
    per_page: perPage,
  });

  const projects = data?.projects ?? [];
  const hasNextPage = data?.pagination?.has_next ?? false;
  const hasPreviousPage = (data?.pagination?.current_page ?? 1) > 1;

  const columns: Column<Project>[] = [
    { header: 'ID', accessor: 'id' },
    { header: '表示名', accessor: 'display_name' },
    { header: 'タイプ', accessor: 'type' },
    {
      header: '作成日',
      accessor: 'created_at',
      cell: (row: Project) => formatDate(row.created_at),
    },
    {
      header: '更新日',
      accessor: 'updated_at',
      cell: (row: Project) => formatDate(row.updated_at),
    },
    {
      header: 'アーカイブ日',
      accessor: 'archived_at',
      cell: (row: Project) => formatDate(row.archived_at),
    },
  ];

  return (
    <div className="space-y-6 px-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">プロジェクト一覧</h1>
        <CreateProjectDialog onSuccess={mutate} />
      </div>
      <DataTable
        data={projects}
        columns={columns}
        page={page}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        onPageChange={handlePageChange}
        isLoading={isLoading}
      />
    </div>
  );
}
